import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { organizationProfileApi } from 'src/api/organization-profile';

type AssistantSummaryResponse = Awaited<
  ReturnType<
    typeof organizationProfileApi.organizationProfileControllerGetVisitAiSummary
  >
>;

export const useAssistantSummaryQuery = (
  profileId: string,
  visitId?: string,
): UseQueryResult<AssistantSummaryResponse> =>
  useQuery(
    ['ai-summary', profileId, visitId],
    () =>
      visitId
        ? organizationProfileApi.organizationProfileControllerGetVisitAiSummary(
            {
              visitId,
            },
          )
        : organizationProfileApi.organizationProfileControllerGetProfileAiSummary(
            {
              profileId,
              visitId: undefined,
            },
          ),
    {
      enabled: Boolean(profileId) || Boolean(visitId),
      refetchOnWindowFocus: false,
      ...(visitId ? { retry: false } : {}),
      refetchInterval: (data, query): number | false => {
        const summary: unknown = data?.data;
        return visitId &&
          query.state.status === 'success' &&
          typeof summary === 'object' &&
          summary !== null &&
          'response' in summary &&
          summary.response === ''
          ? 2000
          : false;
      },
    },
  );
